import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MapProvider } from "react-map-gl/maplibre";

import { useOnlyOnce } from "@nens/react/hooks";
import { DEFAULT_QUERY_OPTIONS } from "@nens/react-query-utils";

import Fonts from "@/theme/fonts";

import { Routes } from "../routes/routes";
import { THEME } from "../theme/theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: DEFAULT_QUERY_OPTIONS,
  },
});

export function App() {
  useOnlyOnce(() => {
    localStorage.removeItem("chakra-ui-color-mode");
  });

  return (
    <ChakraProvider theme={THEME}>
      <Fonts />
      <QueryClientProvider client={queryClient}>
        <MapProvider>
          <Routes />
        </MapProvider>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;
